type SiteHeaderProps = {
	logoUrl: string | null;
};

export function SiteHeader({ logoUrl }: SiteHeaderProps) {
	return (
		<header className="border-b border-[#1a2e26]/15">
			<div className="mx-auto flex max-w-3xl items-center px-6 py-6 sm:px-10">
				{logoUrl ? (
					<img src={logoUrl} alt="Brand" className="h-12 w-auto" />
				) : (
					<img
						src="/maia_logo_secondary_pine.png"
						alt="Maia Wealth"
						className="h-12 w-auto"
					/>
				)}
			</div>
		</header>
	);
}
